/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const CropImageModalZoomIcon: FC<CommonIconProps> = ({ className }) => (
  <svg viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.79707 20.9563V4.55635H21.1971V20.9563H4.79707ZM2.99707 3.75635C2.99707 3.20406 3.44479 2.75635 3.99707 2.75635H21.9971C22.5494 2.75635 22.9971 3.20406 22.9971 3.75635V21.7563C22.9971 22.3086 22.5494 22.7563 21.9971 22.7563H3.99707C3.44479 22.7563 2.99707 22.3086 2.99707 21.7563V3.75635ZM6.5654 17.9647L8.82168 14.8221C9.02117 14.5442 9.43451 14.5442 9.634 14.8221L11.0059 16.733C11.1963 16.9982 11.5857 17.0127 11.7954 16.7624L14.7606 13.2223C14.9628 12.981 15.335 12.9843 15.5329 13.2292L19.3395 17.9422C19.6036 18.2692 19.3708 18.7563 18.9505 18.7563H6.97156C6.56432 18.7563 6.3279 18.2956 6.5654 17.9647Z"
      fill="#272756"
    />
  </svg>
);
